var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBonus = function SvgBonus(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.208008C15.4078 0.208008 19.792 4.59221 19.792 10C19.792 15.4078 15.4078 19.792 10 19.792C4.59221 19.792 0.208008 15.4078 0.208008 10C0.208008 4.59221 4.59221 0.208008 10 0.208008Z",
    fill: "#C79F6C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.208008C15.4078 0.208008 19.792 4.59221 19.792 10C19.792 15.4078 15.4078 19.792 10 19.792C4.59221 19.792 0.208008 15.4078 0.208008 10C0.208008 4.59221 4.59221 0.208008 10 0.208008Z",
    stroke: "white",
    strokeWidth: 0.416667
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1458 9.62252C16.2483 9.67411 16.2806 9.79019 16.2182 9.87841C14.9305 11.7022 12.6272 12.9167 10 12.9167C7.3728 12.9167 5.06945 11.7022 3.78176 9.87893C3.71935 9.79071 3.75173 9.67514 3.85418 9.62303L5.54166 8.76919C5.61761 8.73049 5.71477 8.75268 5.76069 8.81768C6.64035 10.058 8.21007 10.8839 9.99941 10.8839C11.7888 10.8839 13.3591 10.0585 14.2387 8.81768C14.2852 8.75216 14.3818 8.73049 14.4577 8.76919L16.1452 9.62303L16.1458 9.62252Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBonus);
export default ForwardRef;